
// src/pages/ProductDetails/ChargerShowcase.jsx
import React, { useEffect, useRef } from "react";
import "./ChargerShowcase.css";

const ChargerShowcase = ({ productImage, specs }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.15 }
    );
    const els = sectionRef.current.querySelectorAll(".cs-anim");
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="charger-showcase-section" ref={sectionRef}>
      <div className="cs-header cs-anim fade-up">
        <span className="cs-eyebrow">
          <span className="cs-dot"></span> ENGINEERED FOR POWER
        </span>
        <h2 className="cs-title">
          Built different.<br />
          <span className="cs-highlight">Inside and out.</span>
        </h2>
      </div>

      <div className="cs-grid">
        {/* Left Side Features */}
        <div className="cs-col left-col">
          <div className="cs-card cs-anim slide-right delay-1">
            <div className="cs-card-content text-right">
              <h4>Smart CC/CV Profiling</h4>
              <p>Multi-stage logic ensures your lithium cells are charged safely to maximum capacity without over-voltage.</p>
            </div>
            <div className="cs-icon">⚡</div>
          </div>
          <div className="cs-card cs-anim slide-right delay-2">
            <div className="cs-card-content text-right">
              <h4>Auto Cut-Off Logic</h4>
              <p>Actively detects a full battery state and completely stops current flow to prevent degradation.</p>
            </div>
            <div className="cs-icon">🛑</div>
          </div>
        </div>

        {/* Center Product Image */}
        <div className="cs-center cs-anim zoom-in delay-1">
          <div className="cs-image-wrapper">
            <img 
              src={productImage || "https://placehold.co/600x800/111827/4ade80?text=Zynvert+Charger"} 
              alt="Zynvert Charger" 
            />
            <div className="cs-floating-tag">
              <span className="cs-dot"></span> Active Cooling
            </div>
          </div>
        </div>

        {/* Right Side Features */}
        <div className="cs-col right-col">
          <div className="cs-card cs-anim slide-left delay-1">
            <div className="cs-icon">❄️</div>
            <div className="cs-card-content text-left">
              <h4>Thermal Management</h4>
              <p>Integrated fan automatically regulates temperature during long, high-current charging sessions.</p>
            </div>
          </div>
          <div className="cs-card cs-anim slide-left delay-2">
            <div className="cs-icon">🛡️</div>
            <div className="cs-card-content text-left">
              <h4>Surge & Short Protection</h4>
              <p>Built-in safeguards against reverse polarity, short-circuits, and sudden AC voltage spikes.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChargerShowcase;